import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 325,
		margin: "0.2em",
	},
	root2: {
		margin: "0.5em 0",
	},
	root3: {
		margin: "0.5em 0",
		padding: "1em 0",
	},
	content: {
		padding: "0 1em",
	},
	smallPadding: {
		padding: "0 0.4em",
	},
	media: {
		height: 100,
	},
	mediaSecundary: {
		height: 50,
	},
	mediaTertiary: {
		height: 25,
	},
	addMore: {
		"&:hover": {
			color: "orange",
		},
		transition: theme.transitions.create("color", {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expand: {
		transform: "rotate(0deg)",
		marginLeft: "auto",
		transition: theme.transitions.create("transform", {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandOpen: {
		transform: "rotate(180deg)",
	},
	expandDate: {
		marginLeft: "auto",
		transition: theme.transitions.create("color", {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandDateOpen: {
		color: "orange",
	},
	image: { width: "90%", borderRadius: "1em", marginLeft: "0.5em" },
}));

export default useStyles;
